import { combineReducers } from "redux";

import list from "./List/reducer";
import view from "./View/reducer";

const formBsReducer = combineReducers({
  list,
  view,
});

export default formBsReducer;
